<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <textarea :id="id" ref="input" v-bind="{ ...$attrs, class: null }" class="form-textarea" :class="{ error: error }" :style="'min-height:' + minheight" :value="modelValue" @focus="resizeInput" @keyup="resizeInput" @input="$emit('update:modelValue', $event.target.value)" />
    <div v-if="lengthCounter" class="text-xs mt-1">Caracteres: {{ characters }} / {{ $attrs.maxlength }}</div>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `textarea-input-${uuid()}`
      },
    },
    error: String,
    label: String,
    modelValue: String,
    lengthCounter: {
      type: Boolean,
      default: false
    },
    resize: {
      type: Boolean,
      default: false
    },
    minheight: {
      type: String,
      default: '95px'
    },
  },
  computed: {
    characters() {
      return this.modelValue?.length ?? 0;
    }
  },
  emits: ['update:modelValue'],
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    resizeInput() {
      if(this.resize) {
        const input = this.$refs.input;
        input.style.height = input.scrollHeight - 4 + 'px';
      }
    }
  },
}
</script>
